// var $window = $(window);
// var breakPoint = 768;
//
// var resizeFlag = false;
// var windowWidth = $window.width();
// var windowHeight = $window.height();

//anchorLink
// import {anchorLink} from "../include/module";
// anchorLink();

var _isSP;
var windowW       = $(window).width();

//preload
import {preload} from "../include/module";
preload();

//checkSP
import {checkSP} from "../include/module";
checkSP();

//bgAnime
import {bgAnime} from "../include/module";
bgAnime();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//showTtl
import {showTtl} from "../include/module";
showTtl();

$(window).on('resize load' , function() {
  if(windowW <= 767){
    _isSP = true;
  } else {
    _isSP = false;
  };
});


$(document).ready(function(){
  profSlide();

  //ページ外から
  var urlHash = location.hash;
  if(urlHash) {
      setTimeout(function(){
          swiperScroll();
      }, 100);
  }
});

function swiperScroll() {

  var scrollSpeed;
  var scrollTarget   = $('#profile-List');
  var scrollAdjust   = 40;
  var scrollPosition = scrollTarget.offset().top;

  if(!_isSP){
    scrollSpeed = 300;
  }else{
    scrollSpeed = 0;
  }

  $("html, body").animate({scrollTop: scrollPosition - scrollAdjust}, scrollSpeed, "linear");
  return false;
};


$(window).on('load' , function() {
  setTimeout(function(){
      showList();
  }, 200);
});


function showList() {

  var targetPositionAdd;
  targetPositionAdd = 200;
  var windowH       = $(window).innerHeight();
  var scrollPosition = $(window).scrollTop();

  //ファーストビュー内にあるタイトル
  $('.band-List,.sw-Btn').each(function(){
    var targetPosition = $(this).offset().top;
    if(targetPosition < (windowH + scrollPosition)){
      $(this).addClass("show");
    }
  });

  //ファーストビューより下にあるタイトル（スクロールで表示）
  $(window).on('scroll',function(){
    scrollPosition = $(window).scrollTop();
    $('.band-List,.sw-Btn').each(function(){
      var targetPosition = $(this).offset().top;
      if(scrollPosition > targetPosition - windowH + targetPositionAdd){
        $(this).addClass("show");
      }
    });

  });

};

// ------------------------------------------------------------------------
// storySlide
// ----- BOTH
// ------------------------------------------------------------------------
const profSlide = () => {

  var profSwiper;
  profSwiper = new Swiper('.profile-List', {
    // watchOverflow: true,
    hashNavigation: {
      replaceState: true,
    },
    effect: 'fade',
    speed: 0,
    // fadeEffect: {
    //   crossFade: true
    // },
    allowTouchMove: false,//スワイプを可能にするかどうか。デフォルトではtrue。
    // loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      hideOnClick: true,
    },
    on: {
      slideChange: function () {
        swiperScroll();
      },
    }
  });


};



// WEBPACK FOOTER //
// ./src/bangdream_3rd_v0/assets/js/character/script.js